import React, { useEffect, useState, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import Form from 'react-bootstrap/Form';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputSwitch } from 'primereact/inputswitch';
import { useDropzone } from 'react-dropzone';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from "primereact/radiobutton";
import { Divider } from 'primereact/divider';
import MapComponent from '../../MapComponent';
import { Skeleton } from 'primereact/skeleton';

//icons
import Edit from '../../../assets/icons/edit.svg';
import Trash from '../../../assets/icons/trash.svg';
import MapIcon from '../../../assets/icons/map.svg';
import WhiteTrash from '../../../assets/icons/white-trash.svg'
import Upload from '../../../assets/icons/upload.svg'
import { AttachFileCreate, AttachFileDelete, AttachFileUpdate, baseUrl, bearer, CreateBranch, DeleteBranch, GetBranch, SearchBranch, UpdateBranch } from '../../../utils/api';
import { Button, InputGroup } from 'react-bootstrap';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import useToastNotification from '../../../hooks/useToastNotification';
import Loader from '../../loader/loader'


function Banner() {
    const [addFormValidated, setAddFormValidated] = useState(false);
    const [editFormValidated, setEditFormValidated] = useState(false);

    const { showError, showSuccess } = useToastNotification();
    const [addVisible, setAddVisible] = useState(false);
    const [editVisible, setEditVisible] = useState(false);
    const deleteDialog = useRef(null);
    const [status, setStatus] = useState(true);
    const [title, setTilte] = useState('');
    const [catNum, setCatNum] = useState('');
    // const [category, setCategoty] = useState('');
    const [addres, setAddres] = useState('');
    const [code, setCode] = useState('');
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [uploadedFile, setUploadedFile] = useState([]);
    const [labels, setLabels] = useState([]); // To manage the label array
    const [newLabel, setNewLabel] = useState(""); // برای ذخیره لیبل جدید تایپ شده
    const [isAdding, setIsAdding] = useState(false); // برای مدیریت نمایش یا مخفی کردن ورودی لیبل جدید
    const [defaultImg, setDefaultImg] = useState('');
    const [mapVisible, setMapVisible] = useState(false);
    const [mapEditVisible, setMapEditVisible] = useState(false);
    const [lat, setLat] = useState("35.6892");
    const [long, setLong] = useState("51.3890");
    const [loading, setLoading] = useState(false);
    const [tempLat, setTempLat] = useState(null);
    const [tempLng, setTempLng] = useState(null);
    const [tempAddress, setTempAddress] = useState(null);

    const handleAddressSelect = (selectedAddress, lat, lng) => {
        setTempLat(lat);
        setTempLng(lng);
        setTempAddress(selectedAddress);
    };
    const handleEditAddressSelect = (selectedAddress, lat, lng) => {
        setTempLat(lat);
        setTempLng(lng);
        setTempAddress(selectedAddress);
    };
    const [items, setItems] = useState([]);
    const initialSelectedItemProperties = {
        "title": "",
        "isActive": true,
        "lat": "",
        "long": "",
        "code": "",
        "addres": "",
    };
    const [selectedItem, setSelectedItem] = useState({ ...initialSelectedItemProperties });
    const updateSelectedItem = (key, value) => {
        setSelectedItem(old => {
            let clone = { ...old };
            clone[key] = value;
            return clone;
        })
    };


    const [isAddingLabel, setIsAddingLabel] = useState(false);
    const openLabelAdding = () => {
        setIsAddingLabel(true);
        setTimeout(() => {
            document.getElementById('labels-input').focus();
        }, 100);
    };
    const [addingLabelText, setAddingLabelText] = useState('');
    const [imagePreview, setImagePreview] = useState([]);
    const [uploadStatus, setUploadStatus] = useState(null);
    const loadBranchs = async (page = pageIndex, size = pageSize) => {
        setLoading(true)
        try {
            let response = await SearchBranch({
                pageIndex: page,
                pageSize: size,
            });
            setItems(response.data.data.items);
            setTotalRecords(response.data.data.total);
            setLoading(false)


        } catch (error) {
            setLoading(false)

        }
    };

    const loadPage = async () => {
        loadBranchs();
    };
    useEffect(() => {
        let data = [];
        setItems(data);
        loadPage();

    }, [pageIndex, pageSize]);

    const onStatusChange = async (rowData, value) => {
        await UpdateBranch({ ...rowData, isActive: value }).then(() => {
            const updatedItems = items.map(item =>
                item.id === rowData.id ? { ...item, isActive: value } : item
            );
            setItems(updatedItems);
            showSuccess("عملیات با موفقیت انجام شد");
        }).catch(error => showError(error));
    };

    const indexGetter = (_, row) => {
        return row.rowIndex + 1;
    };

    const statusSwitchTemplate = (rowData) => {
        return (
            <InputSwitch
                checked={rowData.isActive}
                onChange={(e) => onStatusChange(rowData, e.value)}
            />
        );
    };

    const actionTemplate = (rowData) => {
        return (
            <div className='d-flex justify-content-center gap-2' style={{ borderRight: '0.5px solid #D2D2D2' }}>
                <img
                    src={Edit}
                    alt="edit"
                    className="cursor-pointer mx-1"
                    onClick={() => openEditDialog(rowData)}
                    style={{ width: '24px', height: '24px' }}
                />
                <img
                    src={Trash}
                    alt="delete"
                    className="cursor-pointer mx-1"
                    onClick={() => openDeleteDialog(rowData)}
                    style={{ width: '24px', height: '24px' }}
                />
            </div>
        );
    };

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });

    const openAddDialog = () => {
        setLoading(false);
        setUploadStatus("");
        setAddVisible(true);
        document.body.style.overflow = 'hidden'; // غیرفعال کردن اسکرول


    };
    const closeAddDialog = (forceClose = false) => {
        if (loading === true && forceClose !== true) return;
        setUploadStatus("");
        setAddVisible(false);
        setAddFormValidated(false)
        document.body.style.overflow = 'auto';
        // reset properties to default
        setImagePreview([]);
        setUploadedFile([]);
        setTilte("");
        setCode("");
        setStatus(true);
    };
    const fixCoordinate = (value) => {
        try {
            console.log(Number(JSON.parse(value)))
            return Number(JSON.parse(value));
        } catch {
            return Number(value); // fallback
        }
    };
    const openEditDialog = (rowData) => {
        setUploadStatus("");

        const fixedLat = fixCoordinate(rowData.lat);
        const fixedLong = fixCoordinate(rowData.long);

        setSelectedItem({
            ...rowData,
            lat: fixedLat,
            long: fixedLong,
        });

        setLat(fixedLat);
        setLong(fixedLong);

        setEditVisible(true);
        document.body.style.overflow = 'hidden';

    };
    const closeEditDialog = (forceClose = false) => {
        if (loading === true && forceClose !== true) return;
        setUploadStatus("");
        setEditVisible(false);
        document.body.style.overflow = 'auto';
    };
    const deleteItem = async (item) => {
        await DeleteBranch({ id: item.id }).then(() => {
            showSuccess("عملیات با موفقیت انجام شد");
            setItems(old => old.filter(filter => item.id !== filter.id));
        }).catch(error => {
            showError(error.response.data.message);
        });
    };

    const openDeleteDialog = async (rowData) => {
        document.body.style.overflow = 'hidden'; // غیرفعال کردن اسکرول

        confirmDialog({
            message: 'آیا از حذف آیتم اطمینان دارید؟',
            header: 'حذف آیتم',
            defaultFocus: 'reject',
            maskClassName: 'flex',
            headerClassName: '!pr-1 !pl-1',
            acceptClassName: 'btn btn-danger mx-1',
            rejectClassName: 'btn btn-secondary mx-1',
            acceptLabel: 'حذف',
            rejectLabel: 'انصراف',
            resizable: false,
            accept: () => {
                deleteItem(rowData)
                document.body.style.overflow = 'auto';
            },
            reject: () => {
                document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول
            },
        });
    };



    // Upload handler for add
    const { getRootProps, getInputProps } = useDropzone({
        onDrop: (acceptedFiles) => {
            if (uploadedFile.length >= 4) {
                showError('حداکثر تعداد عکس ها 4 عدد است');
                return;
            }

            // Append new files
            const newFiles = acceptedFiles.slice(0, 4 - uploadedFile.length); // Limit to the remaining count
            const updatedFiles = [...uploadedFile, ...newFiles];
            setUploadedFile(updatedFiles);

            // Clear previews and set new previews
            const newPreviews = newFiles.map(file => URL.createObjectURL(file));
            let newPreviewsValue = [...imagePreview, ...newPreviews];
            setImagePreview(newPreviewsValue);
            setDefaultImg(newPreviewsValue.length - 1);

            // Automatically upload the file
            // newFiles.forEach(file => handleFileUpload(file));
        },

        accept: 'image/*',
        maxFiles: 4 // Limit to a maximum of 4 files

        // Automatically upload the file
    });



    const handleFileUploadAdd = async (file, id, isDefault) => {
        let base64 = await toBase64(file);
        base64 = base64.substr(base64.indexOf(',') + 1, base64.length);


        // const formData = new FormData();
        // formData.append('filsBase64', base64);
        // formData.append('sourceId', id);
        // formData.append('isDefault', isDefault);
        let formData = {
            sourceId: id,
            filsBase64: base64,
            isDefault
        };


        showSuccess('در حال آپلود فایل');
        await AttachFileCreate(formData)
            .then(data => {
                showSuccess('آپلود فایل با موفقیت انجام شد');
            })
            .catch(error => {
                showError('عملیات آپلود با خطا مواجه شد');
            });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        // if (uploadedFile.length == 0) {
        //     showError("لطفا عکس را وارد کنید.");
        //     return
        // }
        const form = e.currentTarget;
        if (form.checkValidity() === true) {

            try {
                setLoading(true);
                let payload = {
                    title: title,
                    addres: addres,
                    code: code,
                    long: JSON.stringify(long),
                    lat: JSON.stringify(lat),
                    isActive: status,
                };

                let res = await CreateBranch(payload)

                const id = res.data.data; //created item id
                await onAddItemSubmitted(id);
                setLoading(false);
                closeAddDialog();
                showSuccess("عملیات با موفقیت انجام شد");

            } catch (error) {
                setLoading(false);
                showError(error.response?.data?.message);
            }
        } else {
            setAddFormValidated(true)
        }

    };
    const onAddItemSubmitted = async (id) => {
        // add images if exist 
        for (let index = 0; index < uploadedFile.length; index++) {
            const image = uploadedFile[index];
            await handleFileUploadAdd(image, id, index === defaultImg);
        }

        // add new item to the top of the list
        await GetBranch({ id }).then(response => {
            setItems(old => [response.data.data, ...old]);
        }).catch(error => showError(error.response.data));
    }



    // Upload handler for edit
    const { getRootProps: getRootPropsEdit, getInputProps: getInputPropsEdit } = useDropzone({
        onDrop: (acceptedFiles) => {
            if (uploadedFile.length >= 4) {
                showError('حداکثر تعداد عکس ها 4 عدد است');
                return;
            }

            // Append new files
            const newFiles = acceptedFiles.slice(0, 4 - uploadedFile.length); // Limit to the remaining count

            // Automatically upload the file
            newFiles.forEach(file => handleFileUpload(file));
        },

        accept: 'image/*',
        maxFiles: 4 // Limit to a maximum of 4 files
    });

    // Function to handle the file upload
    const handleFileUpload = async (file) => {
        let base64 = await toBase64(file);
        base64 = base64.substr(base64.indexOf(',') + 1, base64.length);


        // const formData = new FormData();
        // formData.append('filsBase64', base64);
        // formData.append('sourceId', selectedItem.id);
        // formData.append('isDefault', true);

        let formData = {
            sourceId: selectedItem.id,
            filsBase64: base64,
            isDefault: true,
        };


        showSuccess('در حال آپلود فایل');
        await AttachFileCreate(formData)
            .then(data => {
                updateImagesList(selectedItem.id);
                showSuccess('آپلود فایل با موفقیت انجام شد');
            })
            .catch(error => {
                showError('عملیات آپلود با خطا مواجه شد');
            });
    };
    const handleRemoveImage = (index) => {
        setUploadedFile(prevFiles => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1); // Remove the file at the specified index
            return newFiles;
        });

        setImagePreview(prevPreviews => {
            const newPreviews = [...prevPreviews];
            newPreviews.splice(index, 1); // Remove the preview at the same index
            return newPreviews;
        });
    };

    const updateImagesList = async (id) => {
        await GetBranch({ id }).then(response => {
            const images = (response.data.data.images);
            setSelectedItem(old => ({ ...old, images }));
        });
    };
    const removeImage = async (image) => {
        await AttachFileDelete({ id: image.id })
            .then(() => {
                setSelectedItem((old) => {
                    // Clone the old object
                    const clone = { ...old };

                    // Filter out the image to be removed from the images array
                    clone.images = clone.images.filter((item) => item.id !== image.id);

                    // Update the isDefault property for the first image if necessary
                    clone.images = clone.images.map((item, index) => {
                        if (index === 0 && image.isDefault === true) {
                            return { ...item, isDefault: true };
                        }
                        return item;
                    });

                    loadPage();
                    return clone;
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const changeDefaultImage = async (id) => {
        console.log(id)
        await AttachFileUpdate({ imageId: id }).then(() => {
            setSelectedItem(old => {
                const clone = { ...old };
                clone.images = clone.images.map(item => {
                    if (item.id === id) {
                        return { ...item, isDefault: true };
                    }
                    else {
                        return { ...item, isDefault: false };
                    }
                })
                return clone;
            })
            loadPage();

        }).catch((error) => {
            console.log(error);
        });
    };

    const submitEdit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        // if (selectedItem.images.length == 0) {
        //     showError("لطفا عکس را وارد کنید.");
        //     return
        // }
        if (form.checkValidity() === true) {
            setLoading(true);
            try {
                let payload = {
                    ...selectedItem,
                    lat: JSON.stringify(selectedItem.lat),
                    long: JSON.stringify(selectedItem.long)
                };

                let response = await UpdateBranch(payload);
                 if (response.status === 200) {
                    setItems(old => {
                        let clone = [...old];
                        clone = clone.map(item => {
                            if (item.id === selectedItem.id) {
                                item = selectedItem;
                            }
                            return item;
                        })
                        return clone;
                    })
                    showSuccess("عملیات با موفقیت انجام شد");
                    closeEditDialog();
                    loadPage();

                }
            } catch (error) {
                showError(error.response.data.message);
            }
            finally {
                setLoading(false);
            }
        } else {
            setEditFormValidated(true)
        }
    };

    // قالب اسکلتون
    const skeletonBodyTemplate = () => {
        return <Skeleton width="100%" height="1.5rem" />;
    };
    const handlePagination = (event) => {
        // Update the pageIndex and pageSize based on the event
        setPageIndex(event.page + 1);
        setPageSize(event.rows);

        loadPage(event.page, event.rows);
    };
    return (
        <div className='branch-list'>
            <div className='w-100 d-flex justify-content-between bg-white p-2 align-items-center border-solid border'>
                <h6 className='font-bold text-sm mb-0'>شعبه ها</h6>
                <button className='btn btn-primary' onClick={openAddDialog}>تعریف شعبه</button>
            </div>
            <div className=''>
                <DataTable value={items}
                    size="small"
                    paginator
                    rows={pageSize}
                    totalRecords={totalRecords}
                    lazy
                    onPage={handlePagination}
                    first={(pageIndex - 1) * pageSize} // Current first record index
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                    tableStyle={{ minWidth: '50rem' }}>
                    <Column header="ردیف" body={indexGetter} ></Column>
                    <Column field="title" header="نام شعبه" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="code" header="کد شعبه" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="addres" header="آدرس شعبه" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column header="وضعیت" body={statusSwitchTemplate}></Column>
                    <Column header="عملیات" body={actionTemplate} ></Column>
                </DataTable>
            </div>

            {/* add category  */}
            <Dialog header="تعریف شعبه" className='branch-list' visible={addVisible} maximizable style={{ width: '40vw' }} onHide={() => { if (!addVisible) return; closeAddDialog(); }}>
                <div className='dialog-body mx-4'>
                    <Form noValidate validated={addFormValidated} className='mt-3' action='#' onSubmit={handleSubmit}>

                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>نام شعبه</Form.Label>
                            <Form.Control type="text" required value={title} onChange={(e) => setTilte(e.target.value)} />
                            <Form.Control.Feedback type="invalid">
                                نام شعبه را وارد کنید
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>کد شعبه</Form.Label>
                            <Form.Control type="number" required value={code} onChange={(e) => setCode(e.target.value)} />
                            <Form.Control.Feedback type="invalid">
                                کد شعبه را وارد کنید
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>آدرس شعبه</Form.Label>
                            <div className='d-flex align-items-center gap-2'>
                                <Form.Control type="text" required value={addres} onChange={(e) => setAddres(e.target.value)} />

                                <button type='button' className='btn' style={{ backgroundColor: '#669D24', minWidth: 'auto', height: 'auto' }} onClick={() => {
                                    setMapVisible(true)
                                    document.body.style.overflow = 'hidden'; // غیرفعال کردن اسکرول

                                }}>
                                    <img src={MapIcon} alt="Map Icon" />
                                </button>
                            </div>     <Form.Control.Feedback type="invalid">
                                آدرس شعبه را وارد کنید
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3 mt-3 d-flex align-items-center justify-content-start gap-3" controlId="exampleForm.ControlInput1">
                            <InputSwitch checked={status} onChange={(e) => setStatus(e.value)} />
                            <Form.Label className='font-bold mb-0' style={{ width: 'fit-content', fontWeight: '700 !important' }}>وضعیت</Form.Label>
                        </Form.Group>
                        <div className="upload-box mt-4 mb-0 flex-1" {...getRootProps()} style={{ borderRadius: '8px', minHeight: '112px', minWidth: '112px' }}>
                            <input {...getInputProps()} />
                            <div>
                                <img src={Upload} alt="" className='mx-auto' />

                                <p className='text-xs mt-2 font-medium'>امکان تعریف 4 تصویر برای هر شعبه وجود دارد.</p>
                                <h6 className='text-[10px]'>بهترین ابعاد: 250 * 250</h6>
                                <h6 className='text-[10px]'>ماکزیمم حجم تصویر: ...</h6>
                            </div>


                        </div>
                        <div className='d-flex gap-2 align-items-center' style={{ flexWrap: 'wrap' }}>
                            {
                                imagePreview.length > 0 &&
                                <div className="image-preview-container d-flex gap-2" style={{ flexWrap: 'wrap' }}>
                                    {imagePreview.map((image, index) => (
                                        <div className='list-defult'>

                                            <div className='d-flex align-items-center gap-2 mt-4' style={{ flexWrap: 'wrap' }}>
                                                <div className='upload-file-btn'>
                                                    <img src={image} alt="Uploaded preview" className="image-preview" />
                                                    <div className='upload-file-btn-bottom'>
                                                        <div className='d-flex align-items-center' >
                                                            <RadioButton inputId={image} name="selected-images" value={index} onChange={(e) => setDefaultImg(e.value)} checked={defaultImg === index} />
                                                            <label htmlFor="ingredient1" className="ml-2">پیش فرض</label>

                                                        </div>
                                                        <div>
                                                            <img src={Trash} alt="" onClick={() => handleRemoveImage(index)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    ))}
                                </div>

                            }


                        </div>



                        {uploadStatus && <p className="upload-status">{uploadStatus}</p>}




                        <button type="submit" disabled={loading} className="btn btn-primary w-100 mt-4">تایید و ثبت {loading && <Loader />}</button>
                    </Form>
                </div>
            </Dialog>



            {/* Edit popup  */}
            <Dialog header="ویرایش  شعبه" className='branch-list' visible={editVisible} maximizable style={{ width: '50vw' }} onHide={() => { if (!editVisible) return; closeEditDialog(); }}>
                <div className='dialog-body mx-4'>
                    <Form noValidate validated={editFormValidated} className='mt-3' onSubmit={submitEdit} onKeyUp={(e) => (e.key === "Enter") && e.preventDefault()}>


                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>نام شعبه</Form.Label>
                            <Form.Control type="text" required value={selectedItem.title} onChange={(e) => updateSelectedItem('title', e.target.value)} />
                            <Form.Control.Feedback type="invalid">
                                نام شعبه را وارد کنید
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>کد شعبه</Form.Label>
                            <Form.Control type="number" required value={selectedItem.code} onChange={(e) => updateSelectedItem('code', e.target.value)} />
                            <Form.Control.Feedback type="invalid">
                                کد شعبه را وارد کنید
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>آدرس شعبه</Form.Label>
                            <div className='d-flex align-items-center gap-2'>
                                <Form.Control type="text" required value={selectedItem.addres} onChange={(e) => updateSelectedItem('addres', e.target.value)} />

                                <button type='button' className='btn' style={{ backgroundColor: '#669D24', minWidth: 'auto', height: 'auto' }} onClick={() => {
                                    setMapEditVisible(true)
                                    document.body.style.overflow = 'auto';
                                }}>
                                    <img src={MapIcon} alt="Map Icon" />
                                </button>
                            </div>   <Form.Control.Feedback type="invalid">
                                آدرس شعبه را وارد کنید
                            </Form.Control.Feedback>
                        </Form.Group>


                        <Form.Group className="mb-3 mt-3 d-flex align-items-center justify-content-start gap-3" controlId="exampleForm.ControlInput1">
                            <InputSwitch checked={selectedItem.isActive} onChange={(e) => updateSelectedItem('isActive', !selectedItem.isActive)} />
                            <Form.Label className='font-bold mb-0' style={{ width: 'fit-content', fontWeight: '700 !important' }}>وضعیت</Form.Label>
                        </Form.Group>
                        <div
                            className="upload-box mt-4 mb-0 flex-1"
                            {...getRootPropsEdit()}
                            style={{ borderRadius: '8px', minHeight: '112px', minWidth: '112px' }}
                        >
                            <input {...getInputPropsEdit()} accept="image/*" />

                            <div>
                                <img src={Upload} alt="آپلود تصویر" className="mx-auto" />
                                <p className="text-xs mt-2 font-medium">امکان تعریف 4 تصویر برای هر شعبه وجود دارد.</p>
                                <h6 className="text-[10px]">بهترین ابعاد: 250 * 250</h6>
                                <h6 className="text-[10px]">ماکزیمم حجم تصویر: ...</h6>
                            </div>
                        </div>
                        {
                            selectedItem.images && <div className="d-flex gap-2 align-items-center" style={{ flexWrap: 'wrap' }}>
                                {selectedItem.images.length > 0 && (
                                    <div className="image-preview-container d-flex gap-2" style={{ flexWrap: 'wrap' }}>
                                        {selectedItem.images.map((image, index) => (
                                            <div key={index} className="list-defult">
                                                <div className="d-flex align-items-center gap-2 mt-4" style={{ flexWrap: 'wrap' }}>
                                                    <div className="upload-file-btn" style={{
                                                        width: '100%',
                                                        maxWidth: '112px',
                                                        minWidth: '112px',
                                                        aspectRatio: '3 / 3'
                                                    }}>
                                                        <img src={baseUrl + 'io/300x300/' + image.url} alt="Uploaded preview" className="image-preview" />
                                                        <div className="upload-file-btn-bottom">
                                                            <div className="d-flex align-items-center">
                                                                <RadioButton
                                                                    inputId={image.id}
                                                                    name="selected-images"
                                                                    value={image.id}
                                                                    onChange={(e) => changeDefaultImage(e.value)}
                                                                    checked={selectedItem.images[index].isDefault}
                                                                />
                                                                <label htmlFor={image.id} className="ml-2">پیش فرض</label>
                                                            </div>
                                                            <div>
                                                                <img src={Trash} alt="حذف" onClick={() => removeImage(image)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}


                            </div>
                        }



                        {uploadStatus && <p className="upload-status">{uploadStatus}</p>}




                        <div className='d-flex align-items-center gap-2 mt-3'>
                            <button type="submit" disabled={loading} className="btn btn-primary flex-1">  تایید و ثبت{loading === true && <Loader />}</button>
                            <button type="button" disabled={loading} className="btn btn-outline-primary flex-1" onClick={closeEditDialog}>انصراف</button>
                        </div>
                    </Form>

                </div >
            </Dialog >
            <Dialog header="موقعیت مکانی" className='branch-list' style={{ width: '50vw' }} visible={mapVisible} maximizable onHide={() => {
                setMapVisible(false)
                document.body.style.overflow = 'auto';
            }}>
                <Divider />
                <h6 className='my-2 mb-4'>لطفا موقعیت مکانی خود را مشخص کنید.</h6>
                <MapComponent
                    lat={lat}
                    lng={long}
                    onSelect={handleAddressSelect}
                />
                <button
                    type='button'
                    className='btn w-100 btn-primary my-4'
                    onClick={() => {
                        if (tempLat !== null && tempLng !== null) {
                            setLat(tempLat);
                            setLong(tempLng);
                        }
                        if (tempAddress) setAddres(tempAddress);

                        setMapVisible(false);
                        document.body.style.overflow = 'auto';
                    }}
                >
                    ثبت
                </button>

            </Dialog>
            <Dialog header="موقعیت مکانی" className='branch-list' style={{ width: '50vw' }} visible={mapEditVisible} maximizable onHide={() => {
                setMapEditVisible(false)
                document.body.style.overflow = 'auto';
            }}>
                <Divider />
                <h6 className='my-2 mb-4'>لطفا موقعیت مکانی خود را مشخص کنید.</h6>
                <MapComponent
                    lat={lat}
                    lng={long}
                    onSelect={handleEditAddressSelect}
                />
                <button
                    type='button'
                    className='btn w-100 btn-primary my-4'
                    onClick={() => {
                        if (tempLat !== null && tempLng !== null) {
                            updateSelectedItem('lat', tempLat);
                            updateSelectedItem('long', tempLng);
                        }
                        if (tempAddress) {
                            updateSelectedItem('addres', tempAddress);
                        }

                        setMapEditVisible(false);
                        document.body.style.overflow = 'auto';
                    }}
                >
                    ثبت
                </button>

            </Dialog>
            <Toast ref={deleteDialog} />
        </div>
    );
}

export default Banner;
